var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"price"},[_c('h3',[_vm._v("公有云部署")]),_c('p',[_vm._v("0启动成本。单价行业内最低！小程序端限免！")]),_c('h3',[_vm._v("私有化部署")]),_c('p',{staticStyle:{"margin-bottom":"40px"}},[_vm._v("请联系 400-646-1860 获取详细报价")]),_c('normal-button',{on:{"click":_vm.handleExperienceClick}},[_vm._v("立即体验")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }